
import { useState } from 'react';
import { usePersistentFormState } from '@/hooks/dashboard/usePersistentFormState';

interface PortfolioState {
  isAdding: boolean;
  isEditing: string | null;
  editingImageId: string | null;
}

export function usePortfolioState(sectionId: string = 'portfolio') {
  const initialState: PortfolioState = {
    isAdding: false,
    isEditing: null,
    editingImageId: null
  };
  
  const [state, setState, resetPersistedState] = usePersistentFormState<PortfolioState>(
    initialState,
    'portfolio_ui_state',
    sectionId
  );
  
  const { isAdding, isEditing, editingImageId } = state;
  
  const handleAddFirstProject = () => {
    setState({ ...state, isAdding: true });
  };
  
  const handleCancelAdd = () => {
    setState({ ...state, isAdding: false });
  };
  
  const handleEditItem = (id: string) => {
    setState({ ...state, isEditing: id });
  };
  
  const handleCancelEdit = () => {
    setState({ ...state, isEditing: null });
  };

  const handleEditImage = (imageId: string) => {
    setState({ ...state, editingImageId: imageId });
  };
  
  const handleCancelEditImage = () => {
    setState({ ...state, editingImageId: null });
  };
  
  const setIsAdding = (value: boolean) => {
    setState({ ...state, isAdding: value });
  };

  // Reset UI state to initial values
  const resetUIState = () => {
    setState(initialState);
  };

  return {
    isAdding,
    isEditing,
    editingImageId,
    handleAddFirstProject,
    handleCancelAdd,
    handleEditItem,
    handleCancelEdit,
    handleEditImage,
    handleCancelEditImage,
    setIsAdding,
    resetUIState,
    resetPersistedState
  };
}
